import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import BreadCrumbs from "./../../components/BreadCrumbs/BreadCrumbs";
import OrderServices from "../../apis/Order/OrderServices";
//* Required Components
import {
  ErrorToaster,
  SuccessToaster,
} from "./../../components/Toaster/Toaster";
import colors from "../../styles/colors";
import { getTimeDate } from "../../utils/DateFormate";
import { Loading } from "./../../components/UI/Loader";
//* MUI Imports
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import {
  Recommend,
  RequestQuote,
  Done,
  Visibility,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";
import {
  Paper,
  Box,
  Grid,
  Typography,
  tooltipClasses,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  IconButton,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
} from "@mui/material";
import useAuth from "../../hooks/useAuth";
import moment from "moment";
import { SecondaryButton } from "../../components/Button/Button";
// import UserDocDialog from "../../components/Dialog/UserDocDialog";
import ProfileServices from "../../apis/Profile/ProfileServices";
import DataFilter from "../../components/Filter/DataFilter";
import { CSVLink } from "react-csv";
import PharmacyServices from "../../apis/Pharmacy/PharmacyServices"
//* Firebase import

//* Table Pagination ActionsComponent
function TablePaginationActions(props) {
  const theme = useTheme;

  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

const tableHead = [
  "Order Id",
  "Date",
  "Pharmacy Name",
  "Customer Name",
  "Payment Mode",
  "Payment Amount",
  "Status",
  "Action",
];

const PharmacyOrders = () => {
  const navigate = useNavigate();
  const { pharmacyId } = useAuth();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState("");
  const [rowsData, setRowsData] = useState([]);
  const [documents, setDocuments] = useState();
  const [docDialog, setDocDialog] = useState(false);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [status, setStatus] = useState("");
  // const [statuses, setStatuses] = useState([]);
  const [selectedPharma, setSelectedPharma] = useState("");
  const role = localStorage.getItem("role");
  const [loader, setLoader] = useState(true);
  const [csvLoading, setCsvLoading] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [comparisonCsvData, setComparisonCsvData] = useState([]);
  const [openDownloadDialog, setOpenDownloadDialog] = useState(false);
const [selectedPharmacy, setSelectedPharmacy] = useState("");
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
const [pharmacies, setPharmacies] = useState([]);

  const csvLink = useRef();

  const statuses = [
    { _id: "Pending", name: "Pending" },
    { _id: "In Progress", name: "In Progress" },
    { _id: "On The Way", name: "On The Way" },
    { _id: "Completed", name: "Completed" },
    { _id: "Cancelled", name: "Cancelled" },
    { _id: "Returned", name: "Returned" },
  ];

  
  const sortByStatus = (stat, id) => {
    console.log(stat, id);
    setRowsPerPage(10);
    setPage(0);
    getOrders(
      page ? page : 1,
      rowsPerPage ? rowsPerPage : 10,
      stat ? stat : "",
      id ? id : "",
      "",
      ""
    );
  };
  useEffect(() => {
    const fetchPharmacies = async () => {
      try {
        const { data } = await PharmacyServices.getPharmacy(); // make sure this API exists
        if (data) 
          setPharmacies(data?.result);
      } catch (error) {
        ErrorToaster("Failed to fetch pharmacies");
      }
    };
    fetchPharmacies();
  }, []);
  

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getOrders(newPage + 1, rowsPerPage, "", "","","");
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Math.floor(event.target.value));
    setPage(0);
    getOrders(1, event.target.value,"","","","");
  };

  const getOrders = async (newPage, rowsPerPage, stat, id) => {
    setLoader(true);
    try {
      const { data } = await ProfileServices.PharmacyOrderList(
        newPage ? newPage : 1,
        rowsPerPage ? rowsPerPage : 10,
        stat ? stat : "",
        id ? id : "",
        "",
        ""
        
      );
      if (data === null) return;
      setRowsData(data.orders);
      setCount(data.count);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getOrders();
  }, []);

  const handleConfirm = async () => {
    const obj = {
      _id: selectedPharma,
      status: status,
    };
    try {
      const { data } = await ProfileServices.PharmacyOrderUpdate(obj);
      getOrders();
      setOpenStatusDialog(false);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  const handleFilteredDownload = async () => {
    setCsvLoading(true);
    setOpenDownloadDialog(false);
  
    try {
      const params = {
        pharmacyId: selectedPharmacy || "",
        from_date: fromDate || "",
        to_date: toDate || "",
      };
  
     
      const { data } = await ProfileServices.PharmacyOrderList(
        1,
        10000,
        "",
        params.pharmacyId,
        params.from_date,
        params.to_date
      );
  
      const filteredOrders = data?.orders || [];
  
      const csvHeaders = [
        { label: "Order ID", key: "order_id" },
        { label: "Customer Name", key: "customer_name" },
        { label: "Customer Phone", key: "customer_phone" },
        { label: "Delivery Address", key: "customer_address" },
        { label: "Payment Amount", key: "payment_amount" },
        { label: "Payment Mode", key: "payment_mode" },
        { label: "Status", key: "status" },
        { label: "Pharmacy Name", key: "pharmacy_name" },
        { label: "Order Date", key: "date" },
      ];
  
      const csvData = filteredOrders.map((order) => ({
        order_id: order?.order_id || "",
        customer_name: order?.customer_name || "",
        customer_phone: order?.customer_phone || "",
        customer_address: order?.customer_address || "",
        payment_amount: order?.payment_amount || "",
        payment_mode: order?.payment_mode || "",
        status: order?.status || "",
        pharmacy_name: order?.pharmacy_id?.name || "",
        date: order?.date ? new Date(order.date).toLocaleString() : "",
      }));
  
      setCsvData([
        csvHeaders.map((header) => header.label),
        ...csvData.map((row) => Object.values(row)),
      ]);
    } catch (error) {
      ErrorToaster("Failed to generate CSV: " + error.message);
    } finally {
      setCsvLoading(false);
    }
  };
  

  useEffect(() => {
    if (csvData.length > 0) {
      csvLink?.current.link.click();
    }
  }, [csvData, comparisonCsvData]);
  return (
    <Fragment>
      <CSVLink
        ref={csvLink}
        data={csvData}
        filename={`Pharmacy-Orders${moment().format("DD-MMM-YYYY_HHmmss")}.csv`}
        target="_blank"
      ></CSVLink>
      <Dialog
  open={openDownloadDialog}
  onClose={() => setOpenDownloadDialog(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>Filter Orders for Excel Download</DialogTitle>
  <DialogContent>
    <FormControl fullWidth sx={{ mt: 2 }}>
      <InputLabel>Pharmacy</InputLabel>
      <Select
        value={selectedPharmacy}
        label="Pharmacy"
        onChange={(e) => setSelectedPharmacy(e.target.value)}
      >
        <MenuItem value="">All Pharmacies</MenuItem>
        {pharmacies.map((p) => (
          <MenuItem key={p._id} value={p._id}>
            {p.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
      <TextField
        label="From Date"
        type="date"
        fullWidth
        InputLabelProps={{ shrink: true }}
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
      />
      <TextField
        label="To Date"
        type="date"
        fullWidth
        InputLabelProps={{ shrink: true }}
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
      />
    </Box>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenDownloadDialog(false)}>Cancel</Button>
    <Button
      variant="contained"
      sx={{ backgroundColor: colors.primary }}
      onClick={() => handleFilteredDownload()}
    >
      Download
    </Button>
  </DialogActions>
</Dialog>

      <Dialog
        maxWidth="md"
        open={openStatusDialog}
        onClose={() => setOpenStatusDialog(false)}
        sx={{
          "& .MuiPaper-elevation": {
            width: "50%",
          },
        }}
      >
        <DialogTitle>Update Status</DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Status</InputLabel>
            <Select
              value={status}
              label="Status"
              onChange={(e) => setStatus(e.target.value)}
            >
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="In Progress">In Progress</MenuItem>
              <MenuItem value="On The Way">On The Way</MenuItem>
              <MenuItem value="Completed">Completed</MenuItem>
              <MenuItem value="Cancelled">Cancelled</MenuItem>
              <MenuItem value="Returned">Returned</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenStatusDialog(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleConfirm} variant="contained" color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          backgroundColor: colors.lightGray,
          p: 3,
          borderRadius: "12px",
          // width: "calc(100vw - 370px)",
        }}
      >
        <Box sx={{ display: "flex", mb: 1, justifyContent: "flex-end" }}>
          <Button
            style={{
              backgroundColor: colors.primary,
              color: "white",
              ml: "-10px",
            }}
            // onClick={() => downloadCsv()}
            onClick={() => setOpenDownloadDialog(true)}
            loading={csvLoading}
          >
            Download Excel
          </Button>
        </Box>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            bgcolor: colors.white,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Pharmacy Orders List
            </Typography>
          </Grid>

          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Pharmacy Orders"]} />
          </Grid>
        </Grid>
        {loader ? (
          <Box sx={{ width: 1, textAlign: "center", pt: 5 }}>
            <Loading />
          </Box>
        ) : (
          <Fragment>
            <Box>
              <DataFilter
                sortData={(
                  selectedId,
                  orderId,
                  name,
                  selectedTypeId,
                  fromDate,
                  toDate,
                  page,
                  rows,
                  selectedPharmaId
                ) => sortByStatus(selectedId, selectedPharmaId,rows, page )}
                data={statuses}
                type={"pharmaOrder"}
                page={page}
                rows={rowsPerPage}
              />
            </Box>
            <TableContainer
              component={Paper}
              sx={{
                "&::-webkit-scrollbar": {
                  bgcolor: colors.white,
                  height: "8px",
                  borderRadius: "10px",
                  cursor: "pointer",
                },
                "&::-webkit-scrollbar-thumb": {
                  bgcolor: colors.primary,
                  borderRadius: "10px",
                  cursor: "pointer",
                },
                "&.MuiPaper-root": {
                  borderRadius: "12px",
                  mt: 2,
                  boxShadow: 0,
                },
              }}
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow sx={{ bgcolor: colors.lightGray }}>
                    {tableHead.map((item, index) => (
                      <TableCell key={index} sx={{ fontWeight: "bold" }}>
                        {item}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowsData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        {row?.order_id || "N/A"}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {moment(row?.date).format("DD/MM/YYYY hh:mm a")}
                      </TableCell>
                      <TableCell>{row?.pharmacy_id?.name || "-"}</TableCell>
                      <TableCell>{row?.customer_name}</TableCell>
                      <TableCell>{row?.payment_mode}</TableCell>
                      <TableCell>{row?.payment_amount}</TableCell>
                      <TableCell>
                        <Chip
                          onClick={() => {
                            // if(role === "A"){

                            setOpenStatusDialog(true);
                            setSelectedPharma(row?._id);
                            // }
                          }}
                          label={row?.status}
                          size="small"
                          variant="outlined"
                          sx={{ cursor: "pointer" }}
                          color={
                            row?.status === "Pending"
                              ? "warning"
                              : row?.status === "In Progress"
                              ? "info"
                              : row?.status === "On The Way"
                              ? "primary"
                              : row?.status === "Completed"
                              ? "success"
                              : row?.status === "Cancelled"
                              ? "error"
                              : row?.status === "Returned"
                              ? "secondary"
                              : "default"
                          }
                        />
                      </TableCell>

                      <TableCell>
                        <Tooltip title="View">
                          <IconButton
                            onClick={() =>
                              navigate("/pharmacy-orders-detail", {
                                state: row,
                              })
                            }
                          >
                            <Visibility sx={{ color: colors.completed }} />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Table sx={{ marginTop: "12px" }}>
              <TablePagination
                sx={{
                  borderBottom: "none",
                  bgcolor: colors.white,
                  borderRadius: "12px",
                }}
                rowsPerPageOptions={[10, 20, 30]}
                colSpan={12}
                count={+count}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    "aria-label": "rows per page",
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Table>
          </Fragment>
        )}
      </Box>
    </Fragment>
  );
};

export default PharmacyOrders;
